(function () {
  'use strict';

  if (window.PBConsentSurface) return;

  var state = { visible: false, kind: null, height: 0, bottomGap: 0, lift: 0 };
  var currentHost = null;
  var currentShadowRoot = null;
  var refreshFrame = null;
  var readinessTimer = null;
  var readinessAttempts = 0;
  var readinessExpired = false;
  var maxAttempts = 40;

  function surfaceIsVisible(surface) {
    if (!(surface instanceof HTMLElement)) return false;
    if (surface.matches('button, button.widget, .widget')) return false;

    var style = window.getComputedStyle(surface);
    if (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      parseFloat(style.opacity || '1') === 0
    ) {
      return false;
    }

    var rect = surface.getBoundingClientRect();
    if (rect.width < 180 || rect.height < 48) return false;
    if (rect.right <= 0 || rect.bottom <= 0 || rect.left >= window.innerWidth || rect.top >= window.innerHeight) {
      return false;
    }

    return true;
  }

  function findVisibleSurface(root) {
    if (!root) return null;

    var preferences = Array.prototype.find.call(
      root.querySelectorAll('.dialog.preferences, .preferences[role="dialog"], [role="dialog"], dialog, .dialog'),
      surfaceIsVisible
    );
    if (preferences) return { element: preferences, kind: 'preferences' };

    var notice = Array.prototype.find.call(
      root.querySelectorAll('.notice, [role="banner"], [aria-label*="privacy" i], [aria-label*="confiden" i]'),
      surfaceIsVisible
    );
    return notice ? { element: notice, kind: 'notice' } : null;
  }

  function stopReadinessPoll() {
    if (readinessTimer === null) return;
    window.clearInterval(readinessTimer);
    readinessTimer = null;
    readinessAttempts = 0;
  }

  function startReadinessPoll() {
    if (!currentHost || currentHost.shadowRoot || readinessTimer !== null || readinessExpired) return;

    readinessAttempts = 0;
    readinessTimer = window.setInterval(function () {
      readinessAttempts += 1;
      if (readinessAttempts >= maxAttempts) readinessExpired = true;
      if (!currentHost || !currentHost.isConnected || currentHost.shadowRoot || readinessExpired) {
        stopReadinessPoll();
      }
      scheduleRefresh();
    }, 100);
  }

  var shadowObserver = new MutationObserver(function () {
    scheduleRefresh();
  });

  function bindCurrentHost() {
    var nextHost = document.querySelector('pandectes-cmp');

    if (nextHost !== currentHost) {
      stopReadinessPoll();
      shadowObserver.disconnect();
      currentHost = nextHost || null;
      currentShadowRoot = null;
      readinessExpired = false;
      observeDocumentTargets();
    }

    var nextShadowRoot = currentHost && currentHost.shadowRoot ? currentHost.shadowRoot : null;
    if (nextShadowRoot !== currentShadowRoot) {
      shadowObserver.disconnect();
      currentShadowRoot = nextShadowRoot;
      if (currentShadowRoot) {
        shadowObserver.observe(currentShadowRoot, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'class', 'hidden', 'open', 'aria-hidden']
        });
      }
    }

    if (currentHost && !currentShadowRoot) startReadinessPoll();
    if (currentShadowRoot) stopReadinessPoll();
  }

  function statesMatch(nextState) {
    return (
      state.visible === nextState.visible &&
      state.kind === nextState.kind &&
      state.height === nextState.height &&
      state.bottomGap === nextState.bottomGap &&
      state.lift === nextState.lift
    );
  }

  function publish(nextState) {
    document.documentElement.classList.toggle('pb-consent-surface-visible', nextState.visible);
    document.body.classList.toggle('pb-consent-surface-visible', nextState.visible);
    if (statesMatch(nextState)) return;

    state = nextState;
    document.dispatchEvent(
      new CustomEvent('pb:consent-surface-visibility', { detail: Object.assign({}, state) })
    );
  }

  function refresh() {
    bindCurrentHost();
    var surface = findVisibleSurface(currentShadowRoot);

    if (!surface) {
      publish({ visible: false, kind: null, height: 0, bottomGap: 0, lift: 0 });
      return;
    }

    var rect = surface.element.getBoundingClientRect();
    var height = Math.ceil(rect.height);
    var bottomGap = Math.ceil(Math.max(0, window.innerHeight - rect.bottom));
    publish({
      visible: true,
      kind: surface.kind,
      height: height,
      bottomGap: bottomGap,
      lift: height + bottomGap + 12
    });
  }

  function scheduleRefresh() {
    if (refreshFrame !== null) return;
    refreshFrame = window.requestAnimationFrame(function () {
      refreshFrame = null;
      refresh();
    });
  }

  function observeDocumentTargets() {
    if (!documentObserver) return;

    documentObserver.disconnect();
    documentObserver.observe(document, { childList: true, subtree: true });
    if (document.documentElement) {
      documentObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
    if (document.body) {
      documentObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
    if (currentHost) {
      documentObserver.observe(currentHost, {
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden', 'open', 'aria-hidden']
      });
    }
  }

  var documentObserver = new MutationObserver(function () {
    scheduleRefresh();
  });

  observeDocumentTargets();
  window.addEventListener('resize', scheduleRefresh, { passive: true });
  window.addEventListener('orientationchange', scheduleRefresh, { passive: true });

  if (window.customElements && typeof window.customElements.whenDefined === 'function') {
    window.customElements.whenDefined('pandectes-cmp').then(scheduleRefresh);
  }

  window.PBConsentSurface = {
    getState: function () { return Object.assign({}, state); },
    refresh: scheduleRefresh
  };

  scheduleRefresh();
})();
